module.exports = __webpack_public_path__ + "img/selected6-min.044df1b5.png";